import {
    Column,
    DivRendererOptions,
    Row,
    Sort,
} from '../grid/experimental.grid';

export enum TemplateID {
    HEADER = 'header',
    CONTENT = 'content',
}

export interface Context {
    templateId: TemplateID;
}

export interface FocusSelectorGrid<
    RowContext extends Context,
    CellContext extends Context,
> {
    columns: Column[];
    rows: Array<Row<RowContext, CellContext>>;
    sortDefs: Sort[];
    defaultSortDefs: Sort[];
    gridRowsTop: Array<Row<RowContext, CellContext>>;
    rendererOpts: DivRendererOptions;
}
